import React from 'react';
import IconButton from 'material-ui/IconButton/index';
import {CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import jMoment from 'moment-jalaali';

import {get} from 'engine/dataServices';

class SiteTraffic extends React.Component {
    constructor(props) {
        super(props);

        jMoment.loadPersian({dialect: 'persian-modern'});

        this.state = {
            data: []
        }
    }

    componentWillMount() {
        this.loadData();
    }

    addDays(date, days) {
        const copy = new Date(Number(date));
        copy.setDate(date.getDate() + days);
        return copy;
    }

    async loadData() {
        const res = await get('Dashboard/SiteTraffic');

        if (res.status == 200) {
            const responseData = await res.json();

            const nowDate = new Date();
            let indexDate = this.addDays(nowDate, -7);

            let _data = [];
            for (let i = 7; i >= 0; i--) {
                const _date = this.addDays(nowDate, i * -1);

                const _users = responseData.Users.find(x => jMoment(x.Date).format('DDD') == jMoment(_date).format('DDD'));
                const _likes = responseData.Likes.find(x => jMoment(x.Date).format('DDD') == jMoment(_date).format('DDD'));
                const _products = responseData.Products.find(x => jMoment(x.Date).format('DDD') == jMoment(_date).format('DDD'));
                const _orders = responseData.Orders.find(x => jMoment(x.Date).format('DDD') == jMoment(_date).format('DDD'));

                _data.push(
                    {
                        date: jMoment(_date).format('jYY/jMM/jDD'),
                        users: _users ? _users.Count : 0,
                        likes: _likes ? _likes.Count : 0,
                        products: _products ? _products.Count : 0,
                        orders: _orders ? _orders.Count : 0
                    });

            }

            this.setState({data: _data})
        }
    }

    render() {
        const {data} = this.state;

        return (
            <div className="jr-card">
                <div className="jr-card-header d-flex align-items-center">
                    <h3 className="mb-0">
                        ترافیک لحظه ای
                    </h3>

                    <div className="ml-auto">
                        <span className="badge bg-green text-white">بروز رسانی زنده</span>
                    </div>
                </div>

                <div className="row mb-4">
                    <div className="col-3">
                        <IconButton className="border-2 border-red ml-3 align-middle">
                            <i className="zmdi zmdi-accounts-alt text-red"/>
                        </IconButton>
                        <span>ثبت نام کاربران</span>
                    </div>
                    <div className="col-3">
                        <IconButton className="border-2 border-primary ml-3 align-middle">
                            <i className="zmdi zmdi-thumb-up text-primary"/>
                        </IconButton>
                        <span>لایک محصولات</span>

                    </div>
                    <div className="col-3">
                        <IconButton className="border-2 border-green ml-3 align-middle">
                            <i className="zmdi zmdi-widgets text-green"/>
                        </IconButton>
                        <span>درج محصولات</span>

                    </div>
                    <div className="col-3">

                        <IconButton className="border-2 border-secondary ml-3 align-middle">
                            <i className="zmdi zmdi-shopping-cart-plus text-secondary"/>
                        </IconButton>
                        <span>ثبت سفارشات</span>
                    </div>
                </div>

                <ResponsiveContainer width="100%" height={350}>
                    <LineChart data={data}
                               margin={{top: 0, right: 0, left: -15, bottom: 0}}>
                        <XAxis dataKey="date"/>
                        <YAxis/>
                        <CartesianGrid strokeDasharray="3 3"/>
                        <Tooltip/>
                        <Line type='monotone' dataKey='orders' stackId="4" stroke='#0c4da2' fill='#0c4da2'/>
                        <Line type='monotone' dataKey='products' stackId="3" stroke='#4CAF50' fill='#4CAF50'/>
                        <Line type='monotone' dataKey='likes' stackId="2" stroke='#fdb813' fill='#fdb813'/>
                        <Line type='monotone' dataKey='users' stackId="1" stroke='#F44336' fill='#F44336'/>
                    </LineChart>
                </ResponsiveContainer>
            </div>
        );
    }
};

export default SiteTraffic;



// WEBPACK FOOTER //
// ./components/toliton/desktop/siteTraffic/siteTraffic.js